import { z } from "zod";

import { baseTimeDataPointSchema } from "./carton-production";

const oeeScoreComponentSchema = z.object({ score: z.number().optional() }).catchall(z.number().optional());

const oeeAvailabilitySchema = oeeScoreComponentSchema.extend({
	plannedProductionTime: z.number().optional(),
	actualRunTime: z.number().optional(),
	downtime: z.number().optional(),
});

const oeeQualitySchema = oeeScoreComponentSchema.extend({
	goodCount: z.number().optional(),
	totalCount: z.number().optional(),
	defectCount: z.number().optional(),
});

const oeePerformanceSchema = oeeScoreComponentSchema.extend({
	idealCycleTime: z.number().optional(),
	actualCycleTime: z.number().optional(),
	totalCount: z.number().optional(),
	runTime: z.number().optional(),
});

const oeeTimeDataSchema = baseTimeDataPointSchema.extend({
	score: z.number().nullable(),
});

const oeeOverTimeDataSchema = z.object({
	metric: z.enum(["Availability", "Quality", "Performance", "OEE"]),
	tenantId: z.string().optional(),
	siteName: z.string().optional(),
	data: z.array(oeeTimeDataSchema),
});

export const oeeResponseSchema = z.object({
	availability: oeeAvailabilitySchema.optional(),
	quality: oeeQualitySchema.optional(),
	performance: oeePerformanceSchema.optional(),
	overTime: z.array(oeeOverTimeDataSchema).optional(),
	isScheduleApplied: z.boolean().optional(),
	lastUpdated: z.string().optional(),
});

export type OEEScoreComponent = z.infer<typeof oeeScoreComponentSchema>;
export type OEEAvailability = z.infer<typeof oeeAvailabilitySchema>;
export type OEEQuality = z.infer<typeof oeeQualitySchema>;
export type OEEPerformance = z.infer<typeof oeePerformanceSchema>;
export type OEEOverTimeData = z.infer<typeof oeeOverTimeDataSchema>;
export type OEEApiResponse = z.infer<typeof oeeResponseSchema>;

export const DEFAULT_OEE_RESPONSE: OEEApiResponse = {
	availability: undefined,
	quality: undefined,
	performance: undefined,
	overTime: [],
	isScheduleApplied: false,
	lastUpdated: undefined,
};
